import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import { apiCall } from "../main/ApiCall";
import { JobDetails } from '../interFaces/interfaces';
const BulkUploadDetails: React.FC = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const [jobDetails, setJobDetails] = useState<JobDetails[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const totalPages = Math.ceil(totalElements / itemsPerPage);
  const clientId = localStorage.getItem("clientId");
  useEffect(() => {
    const fetchJobDetails = async () => {
      if (!jobId) return;
      try {
        const response = await apiCall("get", `/api/bulk-upload/job-details/paginated?page=${currentPage - 1}&size=${itemsPerPage}&jobId=${jobId}&clientId=${clientId}`);
        setJobDetails(response.content || []);
        setTotalElements(response.totalElements || 0);
      } catch (err) {
        setError("Failed to fetch job details.");
      } finally {
        setLoading(false);
      }
    };
    fetchJobDetails();
  }, [jobId, currentPage, itemsPerPage, clientId]);
  const formatDate = (dateString: string | null) => {
    return dateString ? new Date(dateString).toLocaleString() : "N/A";
  };
  const formatFileName = (filePath: string | null) => {
    if (!filePath) return "N/A";
    return filePath.split("/").pop() || filePath;
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Project Data Upload Details</h2>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>S.No</th><th>File Name</th><th>Job Status</th><th>Error Message</th><th>Message</th><th>Created On</th><th>Updated On</th>
              </tr>
            </thead>
            <tbody>
              {jobDetails.length === 0 ? (
                <tr>
                  <td colSpan={8} className="no-data">There are no details available</td>
                </tr>
              ) : (
                jobDetails.map((job, index) => (
                  <tr key={job.jobDetailsId}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{formatFileName(job.fileName) || "N/A"}</td>
                    <td>{(job.jobStatus) || "N/A"}</td>
                    <td>{(job.errorMessage) || "N/A"}</td>
                    <td>{(job.displayMessage) || "N/A"}</td>
                    <td>{formatDate(job.createdDateTime)}</td>
                    <td>{formatDate(job.updatedDateTime)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
    </div>
  );
};
export default BulkUploadDetails;